// extracted by mini-css-extract-plugin
export var blue = "footer-module--blue--Ryj5Y";
export var bottom = "footer-module--bottom--pdi57";
export var container = "footer-module--container--CZE+m";
export var footer = "footer-module--footer--fdIQ7";
export var green = "footer-module--green--Yqb5K";
export var orange = "footer-module--orange--hVDIB";
export var show = "footer-module--show--iPPk3";